import React from "react";
import { NBAuthGuard, NBPlanAccessControlGuard } from "..";
import { NBRoleAccessControlGuard } from "./RoleAccessControlGuard";
/**
 * This component combine the usage of NBAuthGuard and NBRoleAccessControlGuard and NBPlanAccessControlGuard
 * @param param0
 * @returns
 */
const NBAccessControlGuard = ({
  children,
  plans,
  roles
}) => {
  const hasRoles = roles && roles.length > 0;
  const hasPlans = plans && plans.length > 0;
  let elements = null;
  if (hasRoles && hasPlans) {
    elements = /*#__PURE__*/React.createElement(NBAuthGuard, null, /*#__PURE__*/React.createElement(NBRoleAccessControlGuard, {
      roles: roles
    }, /*#__PURE__*/React.createElement(NBPlanAccessControlGuard, {
      plans: plans
    }, children)));
  } else {
    if (hasRoles) {
      elements = /*#__PURE__*/React.createElement(NBAuthGuard, null, /*#__PURE__*/React.createElement(NBRoleAccessControlGuard, {
        roles: roles
      }, children));
    }
    if (hasPlans) {
      elements = /*#__PURE__*/React.createElement(NBAuthGuard, null, /*#__PURE__*/React.createElement(NBPlanAccessControlGuard, {
        plans: plans
      }, children));
    }
  }
  return elements;
};
export { NBAccessControlGuard };